<template>
  <div class="appointmentSelector">
    <v-container fluid>
      <p>Type afspraak*</p>
      <v-select
        v-model="selectedAppointnment"
        :items="appointmentItems"
        item-text="title"
        outlined
        required
        v-on:change="selected"
      ></v-select>
    </v-container>
  </div>
</template>

<script>
    /* eslint-disable */
    import { services } from "../_services";
    import { mapActions } from "vuex";

    export default {
        created: function () {
            services.fetchTypeAfspraak().then(
                (data) => {
                    this.appointmentItems = this.appointmentItems.concat(data);
                },
                (error) => {
                    this.showAlert(error);
                }
            );
        },
        data: function () {
            return {
                selectedAppointnment: {
                    id: null,
                    title: "--Selecteer de gewenste afspraak--",
                    description: "",
                    mediaLink: "",
                },
                appointmentItems: [
                    {
                        id: null,
                        title: "--Selecteer de gewenste afspraak--",
                        description: "",
                        mediaLink: "",
                    },
                ],
            };
        },
        methods: {
            ...mapActions({
                clearAlert: "alert/clear",
                showAlert: "alert/error",
                selectComp: "appBar/selectComp",
                updateFormModel: "appBar/updateFormModel",
            }),
            selected(option) {
                var appointment = this.appointmentItems.find((x) => x.title == option);
                var title = appointment.title;
                var $this = this;

                if (appointment.id == null) {
                    this.updateFormModel({
                        formModel: {
                            id: 1,
                            title: "",
                            selected: false
                        },
                        callback: function () {
                            $this.selectComp({
                                id: 1,
                                type: "select",
                                resetData: false,
                                emptySelection: true,
                            });
                        },
                    });
                    return;
                }

                this.updateFormModel({
                    formModel: {
                        id: 1,
                        title: title,
                        appointmentType: appointment.id,
                        appointmentName: appointment.title,
                        selected: true,
                    },
                    callback: function () {
                        $this.selectComp({
                            id: 1,
                            type: "select",
                            resetData: false,
                            emptySelection: false,
                        });
                    },
                });
            },
        },
    };
</script>